<template>
  <div>
    <div class="mb-12">
      <h2 class="text-181818">Notifications</h2>
      <p class="text-4f4f4f font-normal">Track your project activities</p>
    </div>

    <div>
      <div
        class="flex justify-between items-center mb-6"
        v-for="(item, index) in users"
        :key="'item-' + index"
      >
        <div class="flex items-center">
          <img :src="item.img" alt="image" class="w-16" />
          <div class="pl-4">
            <h4 class="text-181818 mb-0 pb-1">{{ item.title }}</h4>
            <p class="text-929292 text-sm">{{ item.description }}</p>
          </div>
        </div>
        <span class="text-828282">{{ item.date }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      users: [
        {
          id: "01",
          img: require("@/views/adminPanel/pages/builder/NewScreen/img/master/cloud.png"),
          title: "Heads up! UX phase started",
          description: "Miko,UX Designer",
          date: "1st April,2022",
        },
        {
          id: "01",
          img: require("@/views/adminPanel/pages/builder/NewScreen/img/master/cloud.png"),
          title: "Heads up! UX phase started",
          description: "Miko,UX Designer",
          date: "1st April,2022",
        },
        {
          id: "01",
          img: require("@/views/adminPanel/pages/builder/NewScreen/img/master/cloud.png"),
          title: "Heads up! UX phase started",
          description: "Miko,UX Designer",
          date: "1st April,2022",
        },
        {
          id: "01",
          img: require("@/views/adminPanel/pages/builder/NewScreen/img/master/cloud.png"),
          title: "Heads up! UX phase started",
          description: "Miko,UX Designer",
          date: "1st April,2022",
        },
        {
          id: "01",
          img: require("@/views/adminPanel/pages/builder/NewScreen/img/master/cloud.png"),
          title: "Heads up! UX phase started",
          description: "Miko,UX Designer",
          date: "1st April,2022",
        },
      ],
    };
  },
};
</script>
